import React from "react";
import { Skeleton } from "components/ui/skeleton";

/**
 * Single TicketCard skeleton loader
 */
export function TicketCardSkeleton() {
  return (
    <div className="bg-surface dark:bg-dark-800 border border-line dark:border-white/[0.07] rounded-2xl p-4 shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Skeleton variant="text" className="!h-3 !w-16" />
          <Skeleton variant="chip" className="h-5 w-14" />
        </div>
        <Skeleton variant="text" className="!h-3 !w-20" />
      </div>

      {/* Subject */}
      <Skeleton variant="text" className="!h-4 !w-3/4 mb-2" />
      {/* Description */}
      <Skeleton variant="text" className="!h-3 !w-full mb-3" />

      {/* Date row */}
      <div className="flex items-center gap-2">
        <Skeleton className="h-3 w-3 rounded-full" />
        <Skeleton variant="text" className="!h-3 !w-28" />
      </div>
    </div>
  );
}

/**
 * Grid/list skeleton loader for multiple tickets
 */
export function TicketListSkeleton({ count = 5 }) {
  return (
    <div className="space-y-2.5">
      {Array.from({ length: count }).map((_, i) => (
        <TicketCardSkeleton key={i} />
      ))}
    </div>
  );
}
